export default /^\+\d{8,15}$/;
